import React from 'react';
import PropTypes from 'prop-types';
import classes from './BannerSection.module.scss';

const BannerSection = (props) => {
    const { banner_block } = props?.data || {};

    if (!banner_block?.visible) return null;
    if (banner_block?.images?.length === 0) return null;

    return (
        <div className={classes.BannerSection}>
            {banner_block?.images?.map((imgUrl, index) => {
                return (
                    <div key={`${imgUrl}-${index}`} className={classes.BannerImageWrap}>
                        <img src={imgUrl} 
                            className={classes.BannerImage}
                            alt="" />
                    </div>
                )
            })}
        </div>
    )
}

BannerSection.propTypes = {}

export default BannerSection;